import React, { useState } from "react";
import "./App.css";
import './Results.css';


function App() {
  const [series, setSeries] = useState([]);
  const moods = [
    { label: "Cheerful", genre: "35" }, // Comedy
    { label: "Reflective", genre: "18" }, // Drama
    { label: "Gloomy", genre: "9648" }, // Mystery
    { label: "Humorous", genre: "35" }, // Comedy
    { label: "Thrill-Seeking", genre: "80" }, // Crime
  ];

  const fetchSeriesByMood = async (genre) => {
    const API_KEY = process.env.REACT_APP_API_KEY; // Use the environment variable
    const API_URL = `https://api.themoviedb.org/3/discover/tv?api_key=${API_KEY}&with_genres=${genre}`;

    try {
      const response = await fetch(API_URL);
      const data = await response.json();
      console.log("API Response:", data);
      setSeries(data.results || []);
      console.log("Fetched series:", data.results); // Debugging output
    } catch (error) {
      console.error("Error fetching series:", error);
    }
  };

  return (
    <div className="App">
      <h1>Find a Series Based on Your Mood</h1>
      <div className="mood-buttons">
        {moods.map((mood) => (
          <button
            key={mood.genre}
            onClick={() => fetchSeriesByMood(mood.genre)}
            style={{ margin: "10px", padding: "10px", cursor: "pointer" }}
          >
            {mood.label}
          </button>
        ))}
      </div>
      <div className="series-results">
        {series.length === 0 ? (
          <p>No series found for this mood.</p>
        ) : (
          series.map((item, index) => (
            <div className="series-item" key={index}>
              {item.poster_path && (
                <img
                  src={`https://image.tmdb.org/t/p/w200${item.poster_path}`}
                  alt={item.name || "Series Poster"}
                  style={{ marginRight: "15px", borderRadius: "10px" }}
                />
              )}
              <div>
                <h3>{item.name || item.original_name}</h3>
                <p>{item.overview || "No description available."}</p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default App;
